import {
    SET_FINAL_CONFIRMATION,
    SET_FINAL_CONFIRMATION_SUCCESS,
    SET_FINAL_CONFIRMATION_FAILURE,

    TRANSFER_LEAD_TO_BIKE,
    TRANSFER_LEAD_TO_BIKE_FAILURE,
    TRANSFER_LEAD_TO_BIKE_SUCCESS,
} from '../constants/final_confirmation.constants';

export const setFinalConfirmationRequest = params => ({
    type: SET_FINAL_CONFIRMATION, params,
});

export const setFinalConfirmationSuccess = data => ({
    type: SET_FINAL_CONFIRMATION_SUCCESS, data,
});

export const setFinalConfirmationFailure = error => ({
    type: SET_FINAL_CONFIRMATION_FAILURE, error,
});


export const transferLeadToBikeRequest = params => ({
    type: TRANSFER_LEAD_TO_BIKE, params,
});

export const transferLeadToBikeSuccess = data => ({
    type: TRANSFER_LEAD_TO_BIKE_SUCCESS, data,
});

export const transferLeadToBikeFailure = error => ({
    type: TRANSFER_LEAD_TO_BIKE_FAILURE, error,
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/actions/final_confirmation.actions.js